export default "__VITE_ASSET__e2435eba__"